import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "pagestyle" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "dialog-footer" }

import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Banners',
  setup(__props) {

  const searchForm = reactive({
    limit:10,
    page:1,
  })
  const baseData = reactive({
    loading:false,
    title:'',
    addbox:false,
  })
  const form = reactive({
    id:0,
    title:'',
    img:'',
    start_time:'',
    end_time:'',
    status:1,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const uploadImg = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.img = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const save = () => {
    baseData.loading = true
    if(form.id){
      api.bannersApi.edit(form).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.addbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }else{
      api.bannersApi.add(form).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.addbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }
  }
  const getList = () => {
    baseData.loading = true
    api.bannersApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        for(var i in res.data.list){
          res.data.list[i].status = res.data.list[i].status==1?true:false
        }
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const changeStatus = (id:number,status:number) => {
    baseData.loading = true
    if(status){
      status = 1
    }else{
      status = 0
    }
    api.bannersApi.changeStatus({id:id,status:status}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const del = (id:number) => {
    baseData.loading = true
    api.bannersApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = () => {
    baseData.addbox = true
    baseData.title = '添加banner图'
    form.id = 0
    form.title = ""
    form.img = ""
    form.start_time = ""
    form.end_time = ""
    form.status = 1
  }
  const edit = (data:any) => {
    baseData.addbox = true
    baseData.title = '编辑banner图'
    form.id = data.id
    form.title = data.title
    form.img = data.img
    form.start_time = data.start_time
    form.end_time = data.end_time
    form.status = data.status == true ? 1 : 0
  }
  onMounted(() => {
    getList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("banner图设置")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "editbtn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (add()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("创建")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-key": "id",
          border: "",
          data: tableData.data,
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: "标题"
            }),
            _createVNode(_component_el_table_column, {
              label: "图片",
              width: "130"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("img", {
                  src: scope.row.img,
                  style: {"width":"100px","height":"100px","border-radius":"10px"}
                }, null, 8, _hoisted_2)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "start_time",
              label: "开始时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "end_time",
              label: "结束时间"
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_switch, {
                  size: "large",
                  onChange: ($event: any) => (changeStatus(scope.row.id,scope.row.status)),
                  modelValue: scope.row.status,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.status) = $event),
                  "inline-prompt": "",
                  "active-text": "正常",
                  "inactive-text": "暂停"
                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "140"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (edit(scope.row)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_popconfirm, {
                  "confirm-button-text": "是",
                  "cancel-button-text": "否",
                  title: "确定删除吗?",
                  onConfirm: ($event: any) => (del(scope.row.id))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, baseData.loading]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_pagination, {
            "current-page": searchForm.page,
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.page) = $event)),
            "page-size": searchForm.limit,
            "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.limit) = $event)),
            layout: "sizes, prev, pager, next",
            total: tableData.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: baseData.addbox,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((baseData.addbox) = $event)),
      title: baseData.title
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (baseData.addbox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (save()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 提交 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "120"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.title,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.title) = $event)),
                  autocomplete: "off",
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "封面图" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { class: "martop" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      class: "avatar-uploader",
                      action: "",
                      "http-request": uploadImg,
                      "show-file-list": false
                    }, {
                      default: _withCtx(() => [
                        (form.img)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: form.img,
                              class: "avatar"
                            }, null, 8, _hoisted_4))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              class: "avatar-uploader-icon"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Plus)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "开始时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: form.start_time,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.start_time) = $event)),
                  type: "datetime",
                  placeholder: "",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "value-format": "YYYY-MM-DD HH:mm:ss"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "结束时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: form.end_time,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.end_time) = $event)),
                  type: "datetime",
                  placeholder: "",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "value-format": "YYYY-MM-DD HH:mm:ss"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.status,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("正常")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("暂停")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})